import { useEffect } from 'react'
import { tableService } from '../../../../../../app/services/tableService'
import { UpdateTabledata } from '../../../../../../app/services/tableService/updateTable'
import { useFormContext } from 'react-hook-form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '../../../../../components/ui/use-toast'
import { FormEditTableData } from '../TableCard/useTableCardController'
import { useAtom } from 'jotai'
import { selectedTableCardInfo } from '../../../../../../app/store'
import { formatPercentage } from '@/app/utils/comissionPercentage'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'

export const useEditTableCardController = () => {
  const methods = useFormContext<FormEditTableData>()
  const [selectedTableCard] = useAtom(selectedTableCardInfo)
  const queryClient = useQueryClient()

  const { toast } = useToast()

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['updateTable'],
    mutationFn: async ({ data, id }: { data: UpdateTabledata; id: string }) => {
      return tableService.updateTable(data, id)
    },
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ['allTables'],
      })
    },
  })

  const { reset } = methods

  useEffect(() => {
    if (selectedTableCard) {
      const {
        bonus,
        percents,
        name,
        limit,
        maxPercents,
        leaderCommission,
        leaderBonus,
      } = selectedTableCard
      reset({
        name,
        percents: formatPercentage(percents * 100),
        maxPercents: formatPercentage((maxPercents ?? 0) * 100),
        bonus: formatPercentage(bonus * 100 || 0),
        leaderCommission: formatPercentage((leaderCommission ?? 0) * 100),
        leaderBonus: formatPercentage((leaderBonus ?? 0) * 100),
        limit: formatMoneyValue(limit || 0),
      })
    }
  }, [reset])

  const handleEditTableSubmit = async (data: FormEditTableData) => {
    try {
      if (selectedTableCard._id) {
        const formattedData = {
          ...data,
          percents: data.percents ? Number(data.percents) : 0,
          maxPercents: data.maxPercents ? Number(data.maxPercents) : 0,
          bonus: data.bonus ? Number(data.bonus) : 0,
          leaderCommission: data.leaderCommission
            ? Number(data.leaderCommission)
            : 0,
          leaderBonus: data.leaderBonus ? Number(data.leaderBonus) : 0,
          limit: data.limit ? Number(data.limit.replace(/\D/g, '')) : 0,
        }
        const response = await mutateAsync({
          data: formattedData,
          id: selectedTableCard._id,
        })

        if (response.name === data.name) {
          toast({
            title: 'Dados atualizados com sucesso!',
          })
        }
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log(error)
      toast({
        variant: 'destructive',
        title:
          error?.message ||
          'Ocorreu um erro ao tentar atualizar os dados, tente novamente mais tarde.',
      })
    }
  }

  return {
    methods,
    isPending,
    handleEditTableSubmit,
    selectedTableCard,
  }
}
